<template>
  <v-container id="crm" fluid>
    <template v-if="!historyCustomAudiencePage">
      <div
        v-if="['ticket2', 'studio7'].includes(selectedBot.theme)"
        style="width: 40%"
        class="mb-3"
      >
        <multiselect
          v-model="selectedCom7page"
          :allow-empty="false"
          :show-labels="false"
          :searchable="false"
          label="name"
          :options="$store.state.com7pages"
        >
        </multiselect>
        <!-- [{ name: 'All', pageid: null }, ...$store.state.com7pages] -->
      </div>
      <div v-if="isTcpMainPage">
        <v-layout wrap>
          <v-flex xs12 sm6 class="py-3">
            <multiselect
              v-model="filterTcpPage"
              :options="tcpPageOptions"
              select-label
              selected-label
              placeholder="เลือกเพจ"
              label="page_name"
              style="margin-bottom: 4px"
              @input="onSearch"
            ></multiselect>
          </v-flex>
        </v-layout>
      </div>

      <v-layout wrap>
        <v-flex xs12 sm4>
          <h3 class="title">{{ $t('Customer') }}</h3>
        </v-flex>
        <v-flex xs12 sm8 class="text-xs-right">
          <template v-if="loading">
            <v-btn outline loading color="grey"></v-btn>
            <v-btn outline loading color="grey"></v-btn>
          </template>
          <template v-else>
            <template v-if="$store.getters.getPackage != 'premium' || isCoachlab">
              <v-btn color="grey" outline>
                <em class="fas fa-file-import" />
                &nbsp;
                {{ $t('Import') }}&nbsp;
                <v-premium-lock :inline="true"></v-premium-lock>
              </v-btn>
              <v-btn color="grey" outline>
                <em class="fas fa-file-export" />
                &nbsp;
                {{ $t('export') }}&nbsp;
                <v-premium-lock :inline="true"></v-premium-lock>
              </v-btn>
            </template>
            <template v-else>
              <template v-if="selectedBot.facebook_ad_account_id">
                <v-btn
                  style="margin-right: 6px"
                  color="grey"
                  outline
                  @click="createCustomAudienceDialog = true"
                >
                  <em class="fab fa-facebook-square" />
                  &nbsp;
                  {{ $t('Create Custom Audience') }}
                </v-btn>
                <v-menu offset-y>
                  <template #activator="{ on }">
                    <v-btn
                      color="grey"
                      style="display: inline-block; border-radius: 0; margin-left: -10px"
                      outline
                      icon
                      v-on="on"
                    >
                      <v-icon>arrow_drop_down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile @click="historyCustomAudiencePage = true">
                      <v-list-tile-title>{{ $t('ดูรายการที่เคยสร้าง') }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </template>
              <template v-if="computedImportDelay !== true && computedImportDelay > 0">
                <v-btn color="grey" outline>
                  <countdown :time="computedImportDelay * 1000" @end="onCountdownEnd">
                    <template slot-scope="props">
                      <template v-if="props.minutes > 0">
                        {{ props.minutes }}
                        <span class="small">{{ $t('Minutes') }}</span>
                      </template>
                      <template v-else>
                        {{ props.seconds }}
                        <span class="small">{{ $t('Seconds') }}</span>
                      </template>
                    </template>
                  </countdown>
                </v-btn>
              </template>
              <template v-else>
                <v-btn color="grey" outline @click="importCustomer">
                  <em class="fas fa-file-import" />
                  &nbsp;
                  {{ $t('Import') }}
                </v-btn>
              </template>
              <v-btn
                style="margin-right: 6px !important"
                color="grey"
                outline
                @click="onExportCustomer('info')"
              >
                <em class="fas fa-file-export" />
                &nbsp;
                {{ $t('export') }}
              </v-btn>

              <v-menu offset-y>
                <template #activator="{ on }">
                  <v-btn
                    color="grey"
                    dark
                    style="display: inline-block; border-radius: 0; margin-left: -10px"
                    outline
                    icon
                    v-on="on"
                  >
                    <v-icon>arrow_drop_down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile @click="onExportCustomer('dataSummary')">
                    <v-list-tile-title>{{ $t('Export all data summary') }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </template>
          </template>
          <v-btn dark depressed color="primary" @click="showAdvance = !showAdvance">
            <v-icon>search</v-icon>
            &nbsp;
            {{ $t('advanced search') }}&nbsp;
            <em v-if="!showAdvance" class="fas fa-angle-down" />
            <em v-else class="fas fa-angle-up" />
          </v-btn>
        </v-flex>
      </v-layout>
      <div
        v-if="showAdvance"
        class="mb-4"
        style="border: 1px solid #eee; border-radius: 10px; position: relative"
      >
        <v-premium-plan-popup
          v-if="$store.getters.getPackage != 'premium' || isCoachlab"
          :show-all="false"
          margin-top="65"
          style="border-radius: 10px"
        ></v-premium-plan-popup>
        <filter-customer v-if="selectedBot" v-model="filter" :total_user="total_user">
          <v-btn outline color="grey" @click="clearSearch">{{ $t('Clear Search') }}</v-btn>
          <v-btn depressed color="primary" @click="onSearch">
            <em class="fas fa-search mr-1" />
            {{ $t('Search') }}
          </v-btn>

          <div v-if="selectedBot.theme == 'hafele'" slot="append" slot-scope="{ filter }">
            <v-divider class="mt-2"></v-divider>
            <v-layout wrap>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{ $t('Emp ID') }}</label>
                <input
                  v-model="filter.emp_id"
                  type="text"
                  :placeholder="$t('Emp ID')"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{ $t('Emp Name') }}</label>
                <input
                  v-model="filter.emp_first_name"
                  type="text"
                  :placeholder="$t('Emp First Name')"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{ $t('Emp Name') }}</label>
                <input
                  v-model="filter.emp_last_name"
                  type="text"
                  :placeholder="$t('Emp Last Name')"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
            </v-layout>
          </div>
        </filter-customer>
      </div>
      <date-filter
        v-if="['100701258941039'].includes(selectedBot.pageid)"
        v-model="selectedDate"
        default-filter="last_7_days"
        @changeDate="onSearch"
      ></date-filter>
      <v-pagination
        v-model="pageNumber"
        :total-visible="15"
        :length="pagelength"
        @input="changePage"
      ></v-pagination>
      <v-layout row wrap>
        <v-flex xs6></v-flex>
        <v-flex xs6>
          <div class="ma-2 text-xs-right">
            <span class="caption mr-2">{{ $t('Total') }}</span>

            <span :style="`font-size: 19px;color:${$vuetify.theme.primary};font-weight: 600`">{{
              total_user | numberFormat
            }}</span>
          </div>
        </v-flex>
      </v-layout>

      <v-data-table
        :loading="loading"
        :headers="filteredHeader"
        :items="usersFormat"
        class="elevation-1"
        :pagination.sync="pagination"
        hide-actions
      >
        <template #items="props">
          <customer-item v-model="props.item"></customer-item>
        </template>

        <div slot="no-data" class="text-xs-center">{{ $t('No customer') }}</div>
      </v-data-table>

      <div class="mt-4">
        <v-pagination
          v-model="pageNumber"
          :total-visible="15"
          :length="pagelength"
          @input="changePage"
        ></v-pagination>
      </div>

      <v-dialog v-model="showExport" persistent max-width="800" scrollable>
        <v-card>
          <div class="text-xs-right">
            <v-btn fab flat small @click="showExport = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <v-divider></v-divider>
          <v-card-text style="max-height: 600px">
            <v-layout wrap>
              <template v-for="page in exportpagecount">
                <v-flex :key="`expor_${page}`" xs6 sm4 md3 class="pa-2">
                  <div class="z-border-red text-xs-center py-3">
                    <v-icon x-large>folder_shared</v-icon>
                    <div class="caption">
                      {{ ((page - 1) * exportlimit + 1) | numberFormat }} -
                      <template v-if="page == exportpagecount">
                        {{ total_user | numberFormat }}
                      </template>
                      <template v-else>{{ (page * exportlimit) | numberFormat }}</template>
                    </div>
                    <v-btn
                      small
                      color="primary"
                      depressed
                      @click="
                        exportType === 'info'
                          ? exportCustomer((page - 1) * exportlimit)
                          : exportDataSummary((page - 1) * exportlimit)
                      "
                      >download</v-btn
                    >
                  </div>
                </v-flex>
              </template>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="createCustomAudienceDialog" persistent max-width="1000">
        <v-card>
          <div class="text-xs-right">
            <v-btn flat small fab @click="createCustomAudienceDialog = false">
              <v-icon> close </v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <div class="intent-item" style="padding: 10px 15px 0px">
              <form>
                <v-layout wrap>
                  <v-flex xs12 sm12>
                    <div
                      class="form-control pa-1"
                      :class="{ 'has-error': errors.has(`customAudienceName`) }"
                    >
                      <h3 class="mb-2">{{ $t('ตั้งชื่อ Custom Audience') }}</h3>
                      <input
                        v-model="customAudienceName"
                        placeholder="กรุณาใส่ชื่อ Custom Audience"
                        :data-vv-as="$t('Custom Audience Name')"
                        :name="`customAudienceName`"
                        class="form-control mr-3"
                        type="text"
                      />
                      <span v-if="errors.has(`customAudienceName`)" class="text-error">{{
                        errors.first(`customAudienceName`)
                      }}</span>
                    </div>
                    <p class="mt-2">
                      *หมายเหตุ: การทำ Custom Audience กลุ่มเป้าหมายจำควรมีจำนวน 1,000 คน ขึ้นไป
                      หากกลุ่มเป้าหมายมีจำนวนไม่ถึง 1,000 คน แนะนำให้มีการตั้งค่า Lookalike ใน
                      Facebook Ad Manager เพื่อความครอบคลุมในการตั้งค่ากลุ่มเป้าหมาย
                    </p>
                    <p>
                      ทั้งนี้ในการสร้าง Custom Audience จำเป็นที่จะต้องมี Facebook Ads Account
                      เพื่อเชื่อมต่อกับบัญชีโฆษณาธุรกิจโดยตรงเท่านั้น
                      หากท่านยังไม่มีบัญชีโฆษณาธุรกิจ
                      สามารถตรวจสอบรายละเอียดและวิธีการสมัครใช้งานได้
                      <a
                        href="https://www.facebook.com/business/help/910137316041095?id=420299598837059"
                        target="blank"
                      >
                        ที่นี่</a
                      >
                    </p>
                  </v-flex>
                </v-layout>
                <div class="text-xs-center">
                  <v-btn
                    outline
                    color="grey"
                    :loading="loading"
                    @click="createCustomAudienceDialog = false"
                    >{{ $t('cancel') }}</v-btn
                  >
                  <v-btn
                    depressed
                    color="primary"
                    :loading="loading"
                    @click="createCustomAudience"
                    >{{ $t('Save') }}</v-btn
                  >
                </div>
              </form>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template v-else>
      <v-btn flat color="primary" @click="historyCustomAudiencePage = false">
        <em class="fas fa-angle-left mr-2" /> {{ $t('Back') }}
      </v-btn>
      <HistoryAudience @Back="historyCustomAudiencePage = false" />
    </template>
  </v-container>
</template>

<script>
import Customers from './Customers.js'
import HistoryAudience from '@/components/view/customAudience/HistoryAudience.vue'
export default {
  components: {
    HistoryAudience
  },
  mixins: [Customers]
}
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/customer/Customers.vue